import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'admin-knowledge-index',
    template: require('./admin.knowledge-index.html'),
})
export class AdminKnowledgeIndexComponent implements OnInit {

    constructor(private titleService: Title) {}

    ngOnInit(): void {
        this.titleService.setTitle('Knowledge Index');
    }
}
